export default __webpack_public_path__ + "static/background-1-56450e1595511bd8d4f7b94ab493d907.png";